export default function getOptionsWithRequiredToReadChanged(
  currentOptions: Record<string, unknown>[],
  index: number,
  requiredToRead: boolean,
) {
  return currentOptions.map((opt, i) => {
    if (i !== index) return opt;
    return {
      ...opt,
      optionDocumentation: {
        ...(opt.optionDocumentation as Record<string, unknown>),
        requiredToRead,
      },
    };
  });
}
